import {
    MODIFY_MAX_BET,
    FETCH_MAX_BET,
    LIST_MAX_BET
} from "./types";

const init = {
    isLoading: false,
    list: [],
    page: 1,
    size: 10,
    totals: 0
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MAX_BET:
            return {
                ...state,
                ...init,
                isLoading: true,
                filter: payload
            };
        case LIST_MAX_BET:
            return {
                ...state,
                isLoading: false,
                list: payload.data
            };
        case MODIFY_MAX_BET:
            return {
                ...state,
                isLoading: true
            };
        default:
            return state;
    }
}